<ng-template #overlayTpl>
	<div class="cm-context-overlay" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.esc)="close()">
		<div class="cm-context-overlay__actions">
			<span class="cm-context-overlay__title">
				<ng-content select='[cm-overlay-title]'></ng-content>
				<ng-container [ngTemplateOutlet]="titleTpl" [ngTemplateOutletContext]="{ $implicit: titleContext }">
				</ng-container>
			</span>
			<button mat-button cm-mini-button color="primary" (click)="close()"
				[matTooltip]="'Close' | cmLocalize: locFeature + '/_Shared.ContextOverlay.Button.Close'"
				[attr.aria-label]="'Close' | cmLocalize: locFeature + '/_Shared.ContextOverlay.Button.Close'">
				<ats-icon name="ex"></ats-icon>
			</button>
		</div>
		<div class="cm-context-overlay__content" [ngStyle]="style">
			<ng-content></ng-content>
			<ng-container [ngTemplateOutlet]="contentTpl" [ngTemplateOutletContext]="{ $implicit: context }">
			</ng-container>
		</div>
	</div>
</ng-template>
